export const userData = [
  {
    name: "Jan",
    "Active User": 4000,
  },
  {
    name: "Feb",
    "Active User": 3000,
  },
  {
    name: "Mar",
    "Active User": 2000,
  },
  {
    name: "Apr",
    "Active User": 5000,
  },
  {
    name: "May",
    "Active User": 4000,
  },
  {
    name: "Jun",
    "Active User": 5000,
  },
  {
    name: "Jly",
    "Active User": 7000,
  },
  {
    name: "Aug",
    "Active User": 3000,
  },
  {
    name: "Sep",
    "Active User": 4000,
  },
  {
    name: "Oct",
    "Active User": 9000,
  },
  {
    name: "Nov",
    "Active User": 8000,
  },
  {
    name: "Dec",
    "Active User": 14000,
  },
];

export const productData = [
  {
    name: "Jan",
    Sales: 4000,
  },
  {
    name: "Feb",
    Sales: 3000,
  },
  {
    name: "Mar",
    Sales: 5000,
  },
  {
    name: "Apr",
    Sales: 9000,
  },
  {
    name: "May",
    Sales: 7000,
  },
  {
    name: "Jun",
    Sales: 12000,
  },
];

export const userRows = [
  {
    id: 1,
    username: "Nikhil Yadav",
    avatar: "https://ibb.co/0rVk5rG",
    email: "nikhilyadav331@gmail.com",
    status: "active",
    transaction: "Rs. 1200",
  },
  {
    id: 2,
    username: "Nikhil Yadav",
    avatar: "https://ibb.co/jwnW1hf",
    email: "nikhilyadav331@gmail.com",
    status: "active",
    transaction: "Rs. 1200",
  },
  {
    id: 3,
    username: "Nikhil Yadav",
    avatar: "https://ibb.co/0rVk5rG",
    email: "nikhilyadav331@gmail.com",
    status: "active",
    transaction: "Rs. 1200",
  },
  {
    id: 4,
    username: "Nikhil Yadav",
    avatar: "https://ibb.co/jwnW1hf",
    email: "nikhilyadav331@gmail.com",
    status: "active",
    transaction: "Rs. 1200",
  },
  {
    id: 5,
    username: "Nikhil Yadav",
    avatar: "https://ibb.co/0rVk5rG",
    email: "nikhilyadav331@gmail.com",
    status: "active",
    transaction: "Rs. 1200",
  },
  {
    id: 6,
    username: "Nikhil Yadav",
    avatar: "https://ibb.co/jwnW1hf",
    email: "nikhilyadav331@gmail.com",
    status: "active",
    transaction: "Rs. 1200",
  },
  {
    id: 7,
    username: "Nikhil Yadav",
    avatar: "https://ibb.co/0rVk5rG",
    email: "nikhilyadav331@gmail.com",
    status: "active",
    transaction: "Rs. 1200",
  },
  {
    id: 8,
    username: "Nikhil Yadav",
    avatar: "https://ibb.co/jwnW1hf",
    email: "nikhilyadav331@gmail.com",
    status: "active",
    transaction: "Rs. 1200",
  },
  {
    id: 9,
    username: "Nikhil Yadav",
    avatar: "https://ibb.co/0rVk5rG",
    email: "nikhilyadav331@gmail.com",
    status: "active",
    transaction: "Rs. 1200",
  },
  {
    id: 10,
    username: "Nikhil Yadav",
    avatar: "https://ibb.co/jwnW1hf",
    email: "nikhilyadav331@gmail.com",
    status: "active",
    transaction: "Rs. 1200",
  },
];

export const productRows = [
  {
    id: 1,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs.15000",
  },
  {
    id: 2,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs.15000",
  },
  {
    id: 3,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs.15000",
  },
  {
    id: 4,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs.15000",
  },
  {
    id: 5,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs.15000",
  },
  {
    id: 6,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs.15000",
  },
  {
    id: 7,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs.15000",
  },
  {
    id: 8,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs.15000",
  },
  {
    id: 9,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs.15000",
  },
  {
    id: 10,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs.15000",
  },
];
